
Number.prototype.formatDecimals = function(decimals)
{
	return this.toFixed(decimals);
}

Number.prototype.formatGroups = function(decimals)
{
	return this.format({decimals:decimals,group:','});
}

Number.prototype.formatCurrency = function (decimals = 2)
{
  const absVal = Math.abs(this).toFixed(decimals);
  // Accounting format: negatives in parentheses
  if (this < 0)
  {
    return "($" + absVal + ")";
  } else
  {
    return "$" + absVal;
  }
};

Number.prototype.formatPercent = function (decimals = 0)
{
  const absVal = Math.abs(this).toFixed(decimals);
  // Accounting format: negatives in parentheses
  if (this < 0)
  {
    return "(" + absVal + "%)";
  } else
  {
    return absVal + "%";
  }
};

Number.prototype.formatSeconds = function (showSeconds)
{
  if (typeof showSeconds === 'undefined') showSeconds = true;
  if (isNaN(this) || this === null) return null;

  const strlen = showSeconds ? 8 : 5;
  return new Date(this * 1000).toISOString().substr(11, strlen);
};

Number.prototype.formatSize = function ()
{
  const bytes = Number(this);
  if (!isFinite(bytes) || bytes < 0) return '0 Bytes';
  if (bytes === 0) return '0 Bytes';

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);

  return (i === 0)
    ? `${bytes} ${sizes[i]}`
    : `${value.toFixed(2)} ${sizes[i]}`;
};

Number.prototype.formatBoolean = function ()
{
  return (Boolean(this)) ? 'Yes' : 'No';
};

Number.prototype.formatDuration = function ()
{
  let seconds = Math.floor(this);
  if (!isFinite(seconds) || seconds < 0) return "00:00";

  let sec = seconds % 60;
  let min = Math.floor((seconds / 60)) % 60;
  let hours = Math.floor(seconds / 3600);

  sec = sec < 10 ? "0" + sec : sec;
  min = min < 10 ? "0" + min : min;

  if (hours < 1)
  {
    return `${min}:${sec}`;
  } else
  {
    return `${hours}:${min}:${sec}`;
  }
};